import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";

const ContactModal = ({ isOpen, toggle }) => {
  const mobileModalStyles = {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    margin: 0,
    width: "100%",
    maxHeight: "70vh",
    animation: "slideUp 0.3s ease-out",
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className={isMobile ? "modal-bottom" : ""}
      style={isMobile ? mobileModalStyles : {}}
      contentClassName={isMobile ? "border-top-0 rounded-top-3" : ""}
    >
      <ModalHeader
        toggle={toggle}
        className={isMobile ? "border-bottom-0" : ""}
      >
        Contact Options
      </ModalHeader>
      <ModalBody className={isMobile ? "overflow-auto" : ""}>
        <div className="d-flex flex-column gap-4 py-3">
          <div
            className="d-flex align-items-center p-3 rounded-3 border"
            style={{
              background: "rgba(40, 167, 69, 0.1)",
              cursor: "pointer",
            }}
          >
            <div className="bg-success p-3 rounded-circle me-3">
              <i className="fa-solid fa-phone fs-4 text-white"></i>
            </div>
            <div>
              <h5 className="mb-1">Talk to us</h5>
              <span className="text-success fw-medium">9677225944</span>
            </div>
          </div>

          <Link
            to="https://wa.me/919677225944?text=Tell%20me%20more%20about%20Boxs"
            className="text-decoration-none text-dark"
            target="_blank"
          >
            <div
              className="d-flex align-items-center p-3 rounded-3 border"
              style={{
                background: "rgba(37, 211, 102, 0.1)",
                cursor: "pointer",
              }}
            >
              <div
                className="bg-success p-3 rounded-circle me-3"
                style={{ background: "#25D366" }}
              >
                <i className="fa-brands fa-whatsapp fs-4 text-white"></i>
              </div>
              <div>
                <h5 className="mb-1">Chat with us</h5>
                <span className="text-success fw-medium">9677225944</span>
              </div>
            </div>
          </Link>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ContactModal;
